module.exports = __webpack_public_path__ + "static/header-background-1920x1080-665334bb69fa6ef33b2efa06a74fb0ae.jpg";